/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SubjectDTO } from './SubjectDTO';
import {
    SubjectDTOFromJSON,
    SubjectDTOFromJSONTyped,
    SubjectDTOToJSON,
    SubjectDTOToJSONTyped,
} from './SubjectDTO';
import type { UrlDTO } from './UrlDTO';
import {
    UrlDTOFromJSON,
    UrlDTOFromJSONTyped,
    UrlDTOToJSON,
    UrlDTOToJSONTyped,
} from './UrlDTO';
import type { PersonStatusDTO } from './PersonStatusDTO';
import {
    PersonStatusDTOFromJSON,
    PersonStatusDTOFromJSONTyped,
    PersonStatusDTOToJSON,
    PersonStatusDTOToJSONTyped,
} from './PersonStatusDTO';
import type { PersonToOrganisationDTO } from './PersonToOrganisationDTO';
import {
    PersonToOrganisationDTOFromJSON,
    PersonToOrganisationDTOFromJSONTyped,
    PersonToOrganisationDTOToJSON,
    PersonToOrganisationDTOToJSONTyped,
} from './PersonToOrganisationDTO';
import type { PersonEmailDTO } from './PersonEmailDTO';
import {
    PersonEmailDTOFromJSON,
    PersonEmailDTOFromJSONTyped,
    PersonEmailDTOToJSON,
    PersonEmailDTOToJSONTyped,
} from './PersonEmailDTO';
import type { PersonNameDTO } from './PersonNameDTO';
import {
    PersonNameDTOFromJSON,
    PersonNameDTOFromJSONTyped,
    PersonNameDTOToJSON,
    PersonNameDTOToJSONTyped,
} from './PersonNameDTO';
import type { AdminDataPersonDTO } from './AdminDataPersonDTO';
import {
    AdminDataPersonDTOFromJSON,
    AdminDataPersonDTOFromJSONTyped,
    AdminDataPersonDTOToJSON,
    AdminDataPersonDTOToJSONTyped,
} from './AdminDataPersonDTO';
import type { PersonInstitutionalIdDTO } from './PersonInstitutionalIdDTO';
import {
    PersonInstitutionalIdDTOFromJSON,
    PersonInstitutionalIdDTOFromJSONTyped,
    PersonInstitutionalIdDTOToJSON,
    PersonInstitutionalIdDTOToJSONTyped,
} from './PersonInstitutionalIdDTO';
import type { ReferencedProjectDTO } from './ReferencedProjectDTO';
import {
    ReferencedProjectDTOFromJSON,
    ReferencedProjectDTOFromJSONTyped,
    ReferencedProjectDTOToJSON,
    ReferencedProjectDTOToJSONTyped,
} from './ReferencedProjectDTO';
import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface PersonDTO
 */
export interface PersonDTO  {
    /**
     * 
     * @type {number}
     * @memberof PersonDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDTO
     */
    oldId?: string;
    /**
     * 
     * @type {Array<PersonEmailDTO>}
     * @memberof PersonDTO
     */
    personEmails?: Array<PersonEmailDTO>;
    /**
     * 
     * @type {Array<PersonNameDTO>}
     * @memberof PersonDTO
     */
    personNames?: Array<PersonNameDTO>;
    /**
     * 
     * @type {Array<PersonStatusDTO>}
     * @memberof PersonDTO
     */
    personStatuses?: Array<PersonStatusDTO>;
    /**
     * 
     * @type {Array<UrlDTO>}
     * @memberof PersonDTO
     */
    urls?: Array<UrlDTO>;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof PersonDTO
     */
    externalIds?: Array<ExternalIdDTO>;
    /**
     * 
     * @type {Array<PersonInstitutionalIdDTO>}
     * @memberof PersonDTO
     */
    personInstitutionalIds?: Array<PersonInstitutionalIdDTO>;
    /**
     * 
     * @type {Array<PersonToOrganisationDTO>}
     * @memberof PersonDTO
     */
    personOrganisations?: Array<PersonToOrganisationDTO>;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof PersonDTO
     */
    projects?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {Array<SubjectDTO>}
     * @memberof PersonDTO
     */
    personSubjects?: Array<SubjectDTO>;
    /**
     * 
     * @type {AdminDataPersonDTO}
     * @memberof PersonDTO
     */
    adminDataPerson?: AdminDataPersonDTO;
}

/**
 * Check if a given object implements the PersonDTO interface.
 */
export function instanceOfPersonDTO(value: object): value is PersonDTO {
    return true;
}

export function PersonDTOFromJSON(json: any): PersonDTO {
    return PersonDTOFromJSONTyped(json, false);
}

export function PersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'note': json['note'] == null ? undefined : json['note'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
              'personEmails': json['personEmails'] == null ? undefined : ((json['personEmails'] as Array<any>).map(PersonEmailDTOFromJSON)),
              'personNames': json['personNames'] == null ? undefined : ((json['personNames'] as Array<any>).map(PersonNameDTOFromJSON)),
              'personStatuses': json['personStatuses'] == null ? undefined : ((json['personStatuses'] as Array<any>).map(PersonStatusDTOFromJSON)),
              'urls': json['urls'] == null ? undefined : ((json['urls'] as Array<any>).map(UrlDTOFromJSON)),
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
              'personInstitutionalIds': json['personInstitutionalIds'] == null ? undefined : ((json['personInstitutionalIds'] as Array<any>).map(PersonInstitutionalIdDTOFromJSON)),
              'personOrganisations': json['personOrganisations'] == null ? undefined : ((json['personOrganisations'] as Array<any>).map(PersonToOrganisationDTOFromJSON)),
              'projects': json['projects'] == null ? undefined : ((json['projects'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
              'personSubjects': json['personSubjects'] == null ? undefined : ((json['personSubjects'] as Array<any>).map(SubjectDTOFromJSON)),
                  'adminDataPerson': json['adminDataPerson'] == null ? undefined : AdminDataPersonDTOFromJSON(json['adminDataPerson']),
    };
}

export function PersonDTOToJSON(json: any): PersonDTO {
    return PersonDTOToJSONTyped(json, false);
}

export function PersonDTOToJSONTyped(value?: PersonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'note': value['note'],
        'oldId': value['oldId'],
        'personEmails': value['personEmails'] == null? value['personEmails']: (value['personEmails'] as Array<any>).map(PersonEmailDTOToJSON),
        'personNames': value['personNames'] == null? value['personNames']: (value['personNames'] as Array<any>).map(PersonNameDTOToJSON),
        'personStatuses': value['personStatuses'] == null? value['personStatuses']: (value['personStatuses'] as Array<any>).map(PersonStatusDTOToJSON),
        'urls': value['urls'] == null? value['urls']: (value['urls'] as Array<any>).map(UrlDTOToJSON),
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
        'personInstitutionalIds': value['personInstitutionalIds'] == null? value['personInstitutionalIds']: (value['personInstitutionalIds'] as Array<any>).map(PersonInstitutionalIdDTOToJSON),
        'personOrganisations': value['personOrganisations'] == null? value['personOrganisations']: (value['personOrganisations'] as Array<any>).map(PersonToOrganisationDTOToJSON),
        'projects': value['projects'] == null? value['projects']: (value['projects'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'personSubjects': value['personSubjects'] == null? value['personSubjects']: (value['personSubjects'] as Array<any>).map(SubjectDTOToJSON),
        'adminDataPerson': AdminDataPersonDTOToJSON(value['adminDataPerson']),
    };
}


